module.exports = __webpack_public_path__ + "img/Boat_service.0fb65094.jpg";